document.fonts.ready.then(() => {
  let body = document.querySelector('body')
  body.style.fontFamily = 'Regular'
})
